var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pagination-block flex" }, [
    _c(
      "a",
      {
        staticClass: "page-btn flex",
        attrs: { href: "#" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.changePage(1)
          },
        },
      },
      [_vm._v("الصفحة الأولي")]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "pagination" },
      [
        _c(
          "li",
          { staticClass: "page-item", class: { disabled: _vm.current === 1 } },
          [
            _c(
              "a",
              {
                staticClass: "page-link next",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.current - 1)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-angle-double-right" })]
            ),
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.total, function (page) {
          return _c(
            "li",
            {
              key: page,
              staticClass: "page-item",
              class: { active: page === _vm.current },
            },
            [
              _c(
                "a",
                {
                  staticClass: "page-link",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.changePage(page)
                    },
                  },
                },
                [_vm._v(_vm._s(page))]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "page-item",
            class: { disabled: _vm.current === _vm.total },
          },
          [
            _c(
              "a",
              {
                staticClass: "page-link previous",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.changePage(_vm.current + 1)
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-angle-double-left" })]
            ),
          ]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "page-btn flex",
        attrs: { href: "#" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.changePage(_vm.total)
          },
        },
      },
      [_vm._v("الصفحة الأخيرة")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }